'use client';

import Script from 'next/script';
import { ReactNode, useEffect, useState } from 'react';
import { env } from 'next-runtime-env';

declare global {
  interface Window {
    duet?: {
      addMetadata: (metadata: Record<string, string>) => void;
    };
  }
}

const DECAGON_LOADER_SRC = 'https://decagon.ai/loaders/release/base/v1.js';

const DECAGON_SLUG = '3prpwP9_oura_b2b_sales';

const FUNCTIONAL_COOKIE_GROUP = 'C0003';

const hasFunctionalConsent = () =>
  !!window.OptanonActiveGroups?.includes(FUNCTIONAL_COOKIE_GROUP);

export const DecagonChat = (): ReactNode => {
  const [consented, setConsented] = useState(false);
  const environment = env('NEXT_PUBLIC_OURA_ENV');

  useEffect(() => {
    const sync = () => {
      if (hasFunctionalConsent()) setConsented(true);
    };

    sync();
    window.addEventListener('OneTrustGroupsUpdated', sync);

    return () => window.removeEventListener('OneTrustGroupsUpdated', sync);
  }, []);

  if (!consented) {
    return null;
  }

  return (
    // afterInteractive is required: next/script only forwards data-* on the imperative strategies.
    <Script
      id="decagon-chat-loader"
      src={DECAGON_LOADER_SRC}
      data-slug={DECAGON_SLUG}
      strategy="afterInteractive"
      onLoad={() => {
        if (environment) {
          window.duet?.addMetadata({ environment });
        }
      }}
    />
  );
};
